<template>
  <div class="kihonkyuu edit-item" v-if="editingData">
    <div class="head">
      <b v-if="editingData.is_jikyuu">時給</b>
      <b v-else>基本給</b>
    </div>
    <div class="data flex flex-align-center">
      <div class="kingaku">
        <input-text v-model="editingData.kihonkyuu" :type="'number'" inputmode="numeric" class="medium" min="0"
          :error="getError(editingData, 'kihonkyuu')" :disabled="disabled"></input-text>
        <p class="current-data" v-if="editingData?.kihonkyuu">{{ numberFormat(editingData.kihonkyuu) }}</p>
      </div>
      <p class="scale">円</p>
    </div>
  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue';
import OptionConst from '@/const/Option';
import { numberFormat } from '@/filters/common';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();

    return {
      getError,
      OptionConst,
      numberFormat
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';
</style>
